/**
 * Non recoverable error in the presence ping life cycle
 */
export class StopPingError extends Error {}